import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ComponentConfig } from "@measured/puck"
import { FooterProps, RenderConfig } from "./RenderConfig"

export const TamdaMediaFooter: ComponentConfig<FooterProps> = {
  label: "Tamda Media | Footer",
  fields: {
    logoImage: {
      label: "Logo",
      type: "custom",
      render: props => <MediaSelect {...props} mediaType="image" />,
    },
    slogan: {
      label: "Slogan",
      type: "text",
    },
    pagesColumn1: {
      label: "Pages - Cột 1",
      type: "array",
      arrayFields: {
        title: {
          label: "Tiêu đề",
          type: "text",
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    pagesColumn2: {
      label: "Pages - Cột 2",
      type: "array",
      arrayFields: {
        title: {
          label: "Tiêu đề",
          type: "text",
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    pagesColumn3: {
      label: "Pages - Cột 3",
      type: "array",
      arrayFields: {
        title: {
          label: "Tiêu đề",
          type: "text",
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    pagesColumn4: {
      label: "Pages - Cột 4",
      type: "array",
      arrayFields: {
        title: {
          label: "Tiêu đề",
          type: "text",
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    phone: {
      label: "Hotline",
      type: "text",
    },
    email: {
      label: "Email",
      type: "text",
    },
    advertisingContact: {
      label: "Liên hệ quảng cáo",
      type: "text",
    },
    facebookIcon: {
      label: "Facebook Icon",
      type: "custom",
      render: props => <MediaSelect {...props} mediaType="image" />,
    },
    facebookUrl: {
      label: "Facebook URL",
      type: "text",
    },
    youtubeIcon: {
      label: "Youtube Icon",
      type: "custom",
      render: props => <MediaSelect {...props} mediaType="image" />,
    },
    youtubeUrl: {
      label: "Youtube URL",
      type: "text",
    },
    copyrightText: {
      label: "Copyright Text",
      type: "textarea",
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    logoImage: "",
    slogan: "KÊNH THÔNG TIN GẦN GŨI VỚI CỘNG ĐỒNG NGƯỜI VIỆT",
    pagesColumn1: [],
    pagesColumn2: [],
    pagesColumn3: [],
    pagesColumn4: [],
    phone: "+420 771 268 888",
    email: "info@tamdamedia.eu",
    advertisingContact: "info@tamdamedia.eu",
    facebookIcon: "",
    facebookUrl: "https://facebook.com",
    youtubeIcon: "",
    youtubeUrl: "https://youtube.com",
    copyrightText:
      "® 2020-2026 TAMDA MEDIA z.s. Cấm sao chép dưới mọi hình thức nếu không có sự chấp thuận bằng văn bản.\nGhi rõ nguồn TAMDAMEDIA.eu khi phát hành lại thông tin từ website này",
    className: "",
  },
  ...RenderConfig,
}
